export const setSidebarWidth = (value) => {
    localStorage.setItem("sidebarWidth", value);
};

export const getSidebarWidth = () => {
    return localStorage.getItem("sidebarWidth");
};

export const sidebarWidthValue = getSidebarWidth()